<template>
  <v-row>
    <v-col class="py-0">
      <v-row v-if="screen.logo_base64">
        <v-col
          class="py-0  d-flex justify-center"
          offset-sm="4"
          sm="4"
        >
          <v-img
            contain
            height="80pt"
            width="100pt"
            :src="'data:image/jpg;base64,'+screen.logo_base64"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center pb-1">
          <span :style="`color: ${screen.text1.color};font-size: ${screen.text1.size}px`">
            {{ screen.text1.text }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center py-1">
          <span :style="`color: ${screen.text2.color}; font-size: ${screen.text2.size}px`">
            {{ screen.text2.text }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center py-1">
          <span :style="`color: ${screen.text3.color}; font-size: ${screen.text3.size}px`">
            {{ screen.text3.text }}
          </span>
        </v-col>
      </v-row>
      <!-- -->
      <v-row>
        <v-col>
          <v-text-field
            v-model="email"
            dense
            hide-details
            outlined
            label="Введите свой e-mail"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            color="teal"
            width="100%"
            depressed
            @click="onSendCheque"
          >
            Отправить чек
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="showMessage"
          cols="12"
          class="text-center py-1"
        >
          {{ this.message }}
        </v-col>
      </v-row>
      <v-row>
        <!--        <v-col-->
        <!--          cols="9"-->
        <!--          sm="5"-->
        <!--          md="3"-->
        <!--          class="pr-1 text-start payment-text3"-->
        <!--        >-->
        <!--          Чек платежа-->
        <!--        </v-col>-->
        <v-col
          cols="12"
        >
          <v-btn
            color="primary"
            width="100%"
            depressed
            @click="onShowDialog"
          >
            Чек платежа
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            color="info"
            width="100%"
            @click="onReturn"
          >
            На главную
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      v-model="dialogVisible"
      fullscreen
    >
      <v-card>
        <v-toolbar
          flat
          dense
        >
          <v-btn
            icon
            @click="dialogVisible=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!--            <v-toolbar-title>Реквизиты платежа</v-toolbar-title>-->
        </v-toolbar>
        <v-card-text class="px-1 pb-1">
          <div v-html="cheque" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { configuration } from "@/views/loyalty/models/justpay-configuration.model"
import { setScreenBackground } from "@/views/loyalty/shared/modules/utilities"
import { JustpayQrPaymentService } from "@/views/loyalty/shared/services/justpay-qrpayment-service"

export default {
  name: 'ConfigurationFinalScreen',
  props: {
    cheque: {
      type: String,
      default: 'cheque'
    },
    screen: {
      type: Object,
      default: configuration.interface_description.final_screen
    },
  },
  data: () => ({
    dialogVisible: false,
    email: null,
    justpayQrPaymentService: null,
    message: '',
    showMessage: true
  }),
  watch: {
    'screen.background' (newValue) {
      setScreenBackground(newValue)
    }
  },
  beforeMount () {
    this.justpayQrPaymentService = new JustpayQrPaymentService()
  },
  methods: {
    onReturn () {
      // const pointId = localStorage.getItem('pointId')
      const pointId = this.$store.state.pointId
      console.log(pointId)
      if (pointId) { window.location.reload() }
    },
    async onSendCheque () {
      console.log('this.email', this.email)
      console.log('this.order', this.order)
      // TODO send to email
      if (this.email && this.order) {
        this.message = await this.justpayQrPaymentService.sendCheque(this.order.orderId, this.email)
        this.showMessage = true
        setTimeout(() => { this.showMessage = false }, 5000)
      }
    },
    onShowDialog () {
      this.$emit('showCheque')
      this.dialogVisible = true
    },
  }
}
</script>

<style scoped>

</style>
